'use strict';

var d3 = require('d3');
var PooledSeasonalityReviewInputDataChart = function PooledSeasonalityReviewInputDataChart(AbstractChart, chartGroups, chartXAxis, chartYAxis, chartBrush, chartConstants, chartSimpleBars, chartSimpleBarsOverlays, chartTiles) {
  var chartParams = require('./Params');
  var chartScales = require('./Scales');
  var Chart = function Chart(container, formatters) {
    AbstractChart.call(this, container);
    var dispatch = d3.dispatch('rangechange');
    d3.rebind(this, dispatch, 'on');

    // chart components
    var groups = chartGroups('d1', formatters.tooltipFormatter, true);
    var overlay = chartSimpleBarsOverlays('o1');
    var m1Bars = chartSimpleBars('m1');
    var m2Bars = chartSimpleBars('m2');
    var tiles = chartTiles('d1', 'm2', 'tiles').withHeight(3);
    var xAxis = chartXAxis(formatters.xAxisTickFormatter);
    var yAxisLeft = chartYAxis(formatters.yAxisTickFormatter, chartConstants.AXIS.MODE.LEFT).withoutHorizontalLines();
    yAxisLeft.label('Demand');
    var brush = chartBrush();
    brush.on('brushchange', function (range) {
      dispatch.rangechange(range);
      this.brushChangeAction(range, groups);
    }.bind(this));
    this.render = function (data, range) {
      range = range || [0, data.length];
      this.initChart(data, range, chartParams);
      this.scales = chartScales(this.params, this.data, this.visibleXRange);
      this.callForPreDataGroup([brush.withDomainRange(this.visibleXRange)], this.scales);
      this.callForDataGroup([yAxisLeft, groups, m2Bars, m1Bars, tiles, overlay, xAxis], this.scales);
      if (brush.isSelectionInitialized()) {
        brush.updateBrush();
      }
    };
    this.domainChange = function (range) {
      this.render(this.data, range);
    };
    this.setInitialSelection = function (selectionSize) {
      brush.setSelection([0, selectionSize], true);
      brush.updateBrush();
    };
    this.setSelection = function (selectionSize) {
      brush.setSelection([0, selectionSize], true);
      return this;
    };
    this.getSelection = function () {
      var selectedBarsNumbers = brush.getSelection();
      var selectedBars = [];
      for (var i in selectedBarsNumbers) {
        selectedBars[i] = [];
        if (selectedBarsNumbers[i]) {
          for (var j = selectedBarsNumbers[i][0], last = selectedBarsNumbers[i][1]; j < last; j++) {
            selectedBars[i].push(this.data[j]);
          }
        }
      }
      return selectedBars;
    };
    groups.on('groupclick', function (d, i) {
      brush.setSelection([i, i + 1]);
    });
    container.on('$destroy', function () {
      groups.on('groupclick', null);
      brush.on('brushchange', null);
      brush.on('brushend', null);
    });
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
PooledSeasonalityReviewInputDataChart.$inject = ['AbstractChart', 'ChartElementsGroup', 'ChartElementsXAxis', 'ChartElementsYAxis', 'ChartElementsMultiBrush', 'ChartElementsConstants', 'ChartElementsSimpleBars', 'ChartElementsSimpleBarsOverlays', 'ChartElementsTiles'];
module.exports = PooledSeasonalityReviewInputDataChart;